import './Hero.css';
import Placeholder from './Placeholder';
import Icon from './Icon';
import { CALENDLY_URL } from '../config';

export default function Hero() {
  return (
    <section id="top" className="hero">
      <div className="container hero__inner">
        <div className="hero__text">
          <p className="eyebrow hero__eyebrow">
            Communication · Leadership · Workplace&nbsp;Excellence · Emotional&nbsp;Intelligence&nbsp;Coach
          </p>
          <h1 className="hero__title">
            Are <span className="hero__accent">communication</span> gaps holding back your people, your team, or your own <span className="hero__accent">potential</span>?
          </h1>
          <p className="hero__desc">
            Discover practical programs that deliver real outcomes and build confident communicators, stronger leaders, and professionals ready for the future.
          </p>
          <div className="hero__ctas">
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              id="hero-cta"
              className="btn btn-primary"
            >
              Book a complimentary call
            </a>
            <a href="#programs" className="btn btn-secondary">Explore programs</a>
          </div>
        </div>
        <div className="hero__media">
          <div className="hero__stage">
            {/* Drifting gold aura behind the portrait. */}
            <span className="hero__aura" aria-hidden="true" />

            {/* Orbit ring with a travelling dot + a glowing sweep arc. */}
            <span className="hero__sweep" aria-hidden="true" />
            <span className="hero__orbit" aria-hidden="true">
              <span className="hero__orbit-dot" />
            </span>
            <span className="hero__orbit hero__orbit--inner" aria-hidden="true" />

            {/* Floating particles. */}
            <span className="hero__spark hero__spark--1" aria-hidden="true" />
            <span className="hero__spark hero__spark--2" aria-hidden="true" />
            <span className="hero__spark hero__spark--3" aria-hidden="true" />

            <div className="hero__card">
              <Placeholder
                id="hero-portrait"
                src="/assets/img/anjum-hero.webp"
                alt="Anjum Qazi, founder of WAYFWD Strategies"
                objectPosition="50% 18%"
                label="Portrait of Anjum Qazi (hero image)"
                aspect="1 / 1"
                frame="offset"
                className="hero__portrait"
              />
              {/* Ascending-trend accent — the growth / leadership signal. */}
              <span className="hero__growth" aria-hidden="true">
                <svg viewBox="0 0 64 64" width="30" height="30">
                  <polyline
                    className="hero__growth-line"
                    points="8,44 22,32 34,38 44,22 56,12"
                  />
                  <polyline
                    className="hero__growth-arrow"
                    points="47,12 56,12 56,21"
                  />
                  <circle className="hero__growth-dot" cx="56" cy="12" r="3.4" />
                </svg>
              </span>
            </div>

            {/* Floating credential chips. */}
            <span className="hero__chip-float hero__chip-float--a">
              <span className="hero__chip-icon" aria-hidden="true">
                <Icon name="award-ribbon" size={18} strokeWidth={1.8} />
              </span>
              <span className="hero__chip-body">
                <strong>Corporate Trainer</strong>
                <em>&amp; Facilitator</em>
              </span>
            </span>
            <span className="hero__chip-float hero__chip-float--b">
              <span className="hero__chip-icon" aria-hidden="true">
                <Icon name="bar-growth" size={18} strokeWidth={1.8} />
              </span>
              <span className="hero__chip-body">
                <strong>17+ Years</strong>
                <em>Industry experience</em>
              </span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
